// Common
import config from '@/config.js';

// let baseURL = "http://api.new.com/";// 本地测试环境接口域名
// let baseURL = "http://api.new.com/";// 本地测试环境接口域名
// let baseURL = "https://test.api.v1.yywd.vip/";// 云端测试环境接口域名
let baseURL = "https://branch.api.v1.yywd.vip/";// 云端测试环境接口域名
// let baseURL = "https://huawei.api.v1.yywd.vip/";// 华为云端测试环境接口域名
let logoFolder = '';
if (window.location.host.startsWith('report.yywd.vip')) {
    config.debug = false;
    baseURL = "https://api.v1.yywd.vip/";// 生产环境接口域名
} else if (window.location.host.startsWith('sanlian.report.yywd.vip')) {
    config.debug = false;
    baseURL = 'https://sanlian.api.v1.yywd.vip/' // 三联独立部署接口域名  
} else if (window.location.host.startsWith('report.jicainiao.com')) {
    config.debug = false;
    baseURL = 'https://admin.jicainiao.com/' // 三联独立部署接口域名
} else if (window.location.host.startsWith('guadou.report.yywd.vip')) {
    config.debug = false;
    baseURL = "https://guadou.api.v1.yywd.vip/";// 合肥瓜豆独立部署接口域名
} else if (window.location.host.startsWith('wms.report.fengputech.cn')) {
    config.debug = false;
    baseURL = 'https://wms.api.fengputech.cn/' // 蜂铺独立部署接口域名
    logoFolder = 'fengputech/'//自定义logo文件夹
} else if (window.location.host.startsWith('huawei.report.yywd.vip')) {
    config.debug = false;
    baseURL = "https://huawei.api.v1.yywd.vip/";// beta测试环境接口域名
} else if (window.location.host.startsWith('test.report.yywd.vip')) {
    config.debug = false;
    // axios.defaults.baseURL = "https://test.api.v1.yywd.vip/";// 云端测试环境接口域名
    baseURL = "https://branch.api.v1.yywd.vip/";// 云端测试环境接口域名
} else if (window.location.host.startsWith('beta.report.yywd.vip')) {
    config.debug = false
    // axios.defaults.baseURL = "https://beta.api.v1.yywd.vip/";// 云端测试环境接口域名
    baseURL = 'https://beta.api.v1.yywd.vip/' // 云端测试环境接口域名
} else if (window.location.host.startsWith('tmp.report.yywd.vip')) {
    config.debug = false
    // axios.defaults.baseURL = "https://tmp.api.v1.yywd.vip/";// 云端测试环境接口域名
    baseURL = 'http://tmp.api.v1.yywd.vip/' // 云端测试环境接口域名
}
const Headers = {
    debug: false,//for test
    "request-from": "ReportFront",
};

export default {
    LogoFolder: logoFolder,
    BaseURL: baseURL,
    Headers
}